import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import ChangePassword from "../ChangePassword";

export default function Profile() {
    const [client, setClient] = useState({});
    const [editedClient, setEditedClient] = useState({});
    const [loading, setLoading] = useState(false);
    const [editMode, setEditMode] = useState(false);

    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    };

    const GetData = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETADMIN + "?Id=" + localStorage.getItem("userId"), headerconfig)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setClient(response.data.data);
                }
            });
    };
    
    useEffect(() => {
        if (localStorage.getItem('userId')) {
            GetData();
        }
    }, []);
    
    const startEdit = () => {
        setEditedClient({ ...client });
        setEditMode(true);
    };

    const cancelEdit = () => {
        setEditMode(false);
        setEditedClient({});
    };

    const handleUpdate = () => {
        setLoading(true);
        const payload = {
            id: localStorage.getItem("userId"),
            name: editedClient.name,
            phoneNumber: editedClient.phoneNumber,
            email: editedClient.email,
            isActive: true,
            userType:"ADMIN"
        };
        
        axios.post(config.APIACTIVATEURL + config.UPDATEPROFILE, payload, headerconfig)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    handleSuccess("Profile updated successfully");
                    setEditMode(false);
                    setEditedClient({});
                    GetData();
                }
                setLoading(false);
            }).catch(() => setLoading(false));
    };

    return (
        <div id="layout-wrapper">
            <LayoutHeader />
            <LayoutSideBar />
            
            {/* Added bg-light class for light gray background */}
            <div className="body-wrapper bg-light">
                <div className="container-fluid py-4">
                    <div className="row">
                        {/* Left Column - Profile Card */}
                        <div className="col-lg-6">
                            <div className="card shadow-sm h-100">
                                <div className="card-header bg-soft-danger text-white">
                                    <h4 className="mb-0 text-center">Profile Information</h4>
                                </div>
                                <div className="card-body">
                                    <div className="profile-section">
                                        <div className="d-flex justify-content-center mb-3">
                                            <div className="profile-icon bg-light rounded-circle d-flex align-items-center justify-content-center" 
                                                style={{width: '80px', height: '80px'}}>
                                                <i className="fas fa-user fa-2x text-primary"></i>
                                            </div>
                                        </div>
                                        
                                        <div className="profile-details">
                                            <div className="mb-3">
                                                <label className="form-label fw-bold">Name : </label>
                                                {editMode ? (
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={editedClient.name}
                                                        maxLength={40}
                                                        onChange={(e) => setEditedClient({ ...editedClient, name: e.target.value })}
                                                    />
                                                ) : (
                                                    <label className="form-label">{client.name}</label>
                                                )}
                                            </div>
                                            
                                            <div className="mb-3">
                                                <label className="form-label fw-bold">Phone Number : </label>
                                                {editMode ? (
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={editedClient.phoneNumber}
                                                        maxLength={14}
                                                        placeholder="Phone Number with Country Code"
                                                        onChange={(e) => setEditedClient({ ...editedClient, phoneNumber: e.target.value })}
                                                    />
                                                ) : (
                                                    <label className="form-label">{client.phoneNumber}</label>
                                                )}
                                            </div>
                                            
                                            <div className="mb-4">
                                                <label className="form-label fw-bold">Email : </label>
                                                {editMode ? (
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        value={editedClient.email}
                                                        onChange={(e) => setEditedClient({ ...editedClient, email: e.target.value })}
                                                    />
                                                ) : (
                                                    <label className="form-label">{client.email}</label>
                                                )}
                                            </div>
                                        </div>
                                        
                                        <div className="d-flex justify-content-center">
                                            {!editMode ? (
                                                <button className="btn btn-primary px-4" onClick={startEdit}>
                                                    <i className="fas fa-edit me-2"></i>Edit Profile
                                                </button>
                                            ) : (
                                                <>
                                                    <button className="btn btn-success me-2 px-4" onClick={handleUpdate} disabled={loading}>
                                                        {loading ? (
                                                            <>
                                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                Saving...
                                                            </>
                                                        ) : (
                                                            <>
                                                                <i className="fas fa-save me-2"></i>Save Changes
                                                            </>
                                                        )}
                                                    </button>
                                                    <button className="btn btn-outline-danger
 px-4" onClick={cancelEdit}>
                                                        <i className="fas fa-times me-2"></i>Cancel
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Column - Change Password Card */}
                        <div className="col-lg-6 mt-4 mt-lg-0">
                                <div className="card-body">
                                    <ChangePassword />
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}